/* EXPORT ENTITY TYPES */
export * from './board-template/board-template.js'
export * from './theme/theme.js'
export * from './board/board.js'
export * from './group/group.js'
export * from './play-group/play-group.js'

/* IMPORT ENTITIES AND RESOLVERS */
import {
  entities as BoardTemplateEntities,
  resolvers as BoardTemplateResolvers,
  subscribers as BoardTemplateSubscribers
} from './board-template/index.js'
import {
  entities as ThemeEntities,
  resolvers as ThemeResolvers,
  subscribers as ThemeSubscribers
} from './theme/index.js'
import {
  entities as BoardEntities,
  resolvers as BoardResolvers,
  subscribers as BoardSubscribers
} from './board/index.js'
import { entities as GroupEntities, resolvers as GroupResolvers } from './group/index.js'
import {
  entities as PlayGroupEntities,
  resolvers as PlayGroupResolvers,
  subscribers as PlayGroupSubscribers
} from './play-group/index.js'
import { resolvers as IntegrationAnalysisQuery } from './analysis/index.js'
import { entities as BoardFavoriteEntities, resolvers as BoardFavoriteResolvers } from './board-favorite/index.js'
import { subscribers as PermissionSubscriber } from './permission/index.js'

export const entities = [
  /* ENTITIES */
  ...BoardTemplateEntities,
  ...ThemeEntities,
  ...BoardEntities,
  ...GroupEntities,
  ...PlayGroupEntities,
  ...BoardFavoriteEntities
]

export const subscribers = [
  /* SUBSCRIBERS */
  ...BoardTemplateSubscribers,
  ...ThemeSubscribers,
  ...BoardSubscribers,
  ...PlayGroupSubscribers,
  ...PermissionSubscriber
]

export const schema = {
  resolverClasses: [
    /* RESOLVER CLASSES */
    ...BoardTemplateResolvers,
    ...ThemeResolvers,
    ...BoardResolvers,
    ...GroupResolvers,
    ...PlayGroupResolvers,
    ...IntegrationAnalysisQuery,
    ...BoardFavoriteResolvers
  ]
}
